import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'alert-small-off', 'AlertSmallOff', [["path",{"d":"M12 16h.01"}],["path",{"d":"M12 7v1"}],["path",{"d":"M3 3l18 18"}]]);